<h1 mat-dialog-title>Add Vouch</h1>
<mat-dialog-content [formGroup]="form">
  <ng-container *ngIf="!isUpgrade">
    <div>
      By vouching for this person, it means that you firmly believe, based on evidence, that:
      <ul>
        <li>they are a real person representing themself accurately</li>
        <li>they have played the number and type of rooms that they claim</li>
        <li>they have clearly disclosed any conflicts of interest and listed any relevant affiliations in their bio by name</li>
        <li>all of their public-facing data (name, city, bio) is complete, accurate, and properly formatted</li>
      </ul>
    </div>
    <p>
      <mat-form-field appearance="fill" subscriptSizing="dynamic">
        <mat-label>How did you confirm their identity?</mat-label>
        <textarea matInput formControlName="identity" required
                  cdkTextareaAutosize #identityAutosize="cdkTextareaAutosize" cdkAutosizeMinRows="2"></textarea>
        <mat-hint>This can be done with (non-Discord) social media accounts, checking with known references, or personally knowing them.</mat-hint>
      </mat-form-field>
    </p>
  </ng-container>
  <p>
    <mat-form-field appearance="fill" subscriptSizing="dynamic">
      <mat-label>How did you confirm their room count?</mat-label>
      <textarea matInput formControlName="experience" required
                cdkTextareaAutosize #experienceAutosize="cdkTextareaAutosize" cdkAutosizeMinRows="2"></textarea>
      <mat-hint>This can be done with room tracking sites, detailed spreadsheets, checking with known references, or personally knowing their experience.</mat-hint>
    </mat-form-field>
  </p>
  <p>
    <mat-checkbox formControlName="affiliationsDisclosed" required>
      I am confident that this person has transparently disclosed all potential affiliations, past and present, and has mentioned any such affiliations by name in their bio.
    </mat-checkbox>
  </p>
</mat-dialog-content>
<div mat-dialog-actions align="end">
  <button mat-raised-button color="secondary" (click)="cancel()">
    Cancel
  </button>
  <button mat-raised-button color="primary" (click)="submit()" [disabled]="form.invalid">
    Submit
  </button>
</div>
